var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1429 3C7.35619 3 4.28571 6.13444 4.28571 10H2L4.96381 13.0256L5.01714 13.1344L8.09524 10H5.80952C5.80952 6.99 8.19429 4.55556 11.1429 4.55556C14.0914 4.55556 16.4762 6.99 16.4762 10C16.4762 13.01 14.0914 15.4444 11.1429 15.4444C9.67238 15.4444 8.33905 14.83 7.37905 13.8422L6.29714 14.9467C7.53905 16.2144 9.24571 17 11.1429 17C14.9295 17 18 13.8656 18 10C18 6.13444 14.9295 3 11.1429 3ZM10.381 6.88889V10.7778L13.619 12.7378L14.2057 11.7422L11.5238 10.1167V6.88889H10.381Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.f816063f6afd20d34ff349e7ed18ebca.svg";
export { ForwardRef as ReactComponent };